/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { noop, startsWith } from 'lodash';
import { Field } from 'react-final-form';
import { Text } from '@blend/enterprise-components';

import { BlendBridge } from 'blb-types/blendBridge';
import { forgotPassword } from 'blb-api/auth';
import { FormCard } from 'blb-components/FormCard';
import { usernameInputConfig } from 'blb-inputs/unauthenticated';
import { useLoginFlowSubmit, extractValue } from 'blb-utils/login';
export namespace ForgotPasswordPage {
  export interface Props {}
}

export const ForgotPasswordPage: React.FC<ForgotPasswordPage.Props> = ({}) => {
  const onSubmit = useLoginFlowSubmit(forgotPassword, noop);

  const usernameFromParams = (() => {
    const qs = window.location.search.slice(1);
    if (!startsWith(qs, 'username')) return undefined;
    return extractValue(decodeURIComponent(qs));
  })();

  return (
    <FormCard<BlendBridge.API.ResetPasswordBody>
      headerLabel={
        <Text>
          Enter your email below and Blend will send you an email to reset your password. Follow the instructions on the
          next screen to complete the process.
        </Text>
      }
      headerTitle="Forgot your Password?"
      id="ForgotPassword"
      onSubmit={onSubmit}
      submitLabel="Reset my password"
    >
      <Field {...usernameInputConfig} initialValue={usernameFromParams} />
    </FormCard>
  );
};
